import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ResultButton } from '../../../../shared/detailed-result-buttons/detailed-result-buttons.component';
import { ModalService } from 'src/app/@shared/services/modal/modal.service';
import { StopFullData } from 'src/app/modules/route-planner/interfaces/route-planning/service/@schedule-service.interface';
import { SpecialMessage } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/special-messages/special-message.interface';
import { QueryParamsService } from 'src/app/@shared/services/query-params/query-params.service';
import { eTab } from 'src/app/modules/route-planner/enums/route-planning/tabs/tabs.enums';
import { UtilsService } from 'src/app/@shared/services/utils/utils.service';
import { Coordinate } from 'src/app/modules/route-planner/interfaces/location/coordinate.interface';
import {
  Language,
  LanguageService,
} from 'src/app/@shared/services/language/language.service';
import { Direction } from '@angular/cdk/bidi';
import {
  ALREADY_RATED,
  DROP_OFF_ONLY,
  LINES_IN_STATION,
  MY_LOCATION,
  NAVIGATE_TO_STATION,
  NO_PICKUP_OR_DROP_OFF,
  OPEN_STATION_PHOTO_ARIA_LABEL,
  PICK_UP_ONLY,
  PLATFORM,
  RATE,
  RATE_STATION,
  SIGN_UP_FOR_REPORTS,
  SIGN_UP_FOR_REPORTS_EXTERNAL_HINT,
  SIGN_UP_FOR_REPORTS_URL,
  SPECIAL_DATA_TEXTS,
  SPECIAL_MESSAGES,
  specialMessagesButtonAriaLabel,
  STATION,
  STATION_PHOTO_ALT,
  STATION_PICTURE,
  SUBMIT_REQUEST_COMPLAIN,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { ImageCarouselComponent } from 'src/app/@shared/components/pop-ups/image-carousel/image-carousel.component';
import { UserLocationService } from 'src/app/@shared/services/user-location/user-location.service';
import { LocationService } from 'src/app/modules/route-planner/services/location/location.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { Rating } from 'src/app/modules/route-planner/interfaces/route-planning/rating.interface';
import { LineRatingComponent } from '../../../../shared/pop-ups/line-rating/line-rating.component';
import { AutoCompleteService } from 'src/app/modules/route-planner/services/auto-complete/auto-complete.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { Route } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/route.interface';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-search-station-deatiled-result-details',
    templateUrl: './search-station-deatiled-result-details.component.html',
    styleUrls: ['./search-station-deatiled-result-details.component.scss'],
    standalone: false
})
export class SearchStationDeatiledResultDetailsComponent implements OnInit {
  @Input() stop: StopFullData;
  @Output() closeCardEvent = new EventEmitter<void>();
  @Output() navigateToStationEvent = new EventEmitter<boolean>();

  direction: Direction;
  stationPicturesText: string;
  linesInStationText: string;

  myLocationText: string;
  alreadyRatedText: string;
  rateText: string;
  platformText: string
  specialMessagesText: string
  onlyDropOffText: string
  pickUpOnlyText: string
  noPickupOrDropOffText: string
  isRatedStop: boolean;
  /**
   * Cached language key used by `stationPhotoAlt` and
   * `stationPhotoButtonAriaLabel` so we don't query the language service per
   * row when Angular re-renders the photo grid.
   */
  private languageKey: string = 'hebrew';


  resultButtons: ResultButton[] = [];

  constructor(
    private readonly modalService: ModalService,
    private readonly queryParamsService: QueryParamsService,
    private readonly userLocationService: UserLocationService,
    private readonly languageService: LanguageService,
    private readonly locationService: LocationService,
    private readonly autoCompleteService: AutoCompleteService,
    private readonly routePlanningService: RoutePlanningService,
    private readonly resizeService: ResizeService
  ) {}

  ngOnInit(): void {
    this.initializeMultiLanguageTexts();

    let ratedStops = JSON.parse(localStorage.getItem('ratedStopCode') || '[]');
    let ratedStop = ratedStops.find(item => item.value === this.stop.stopcode.toString());
    if (ratedStop) {
      if (ratedStop.expiration <= Date.now()) {
        ratedStops = ratedStops.filter(item => item.value !== this.stop.stopcode.toString());
        localStorage.setItem('ratedStopCode', JSON.stringify(ratedStops));
        ratedStop = null;
      }
    }
    this.isRatedStop = !!ratedStop;

  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      this.direction = language.direction;
      this.languageKey = language.language;
      this.stationPicturesText = STATION_PICTURE[language.language];
      this.linesInStationText = LINES_IN_STATION[language.language];
      this.myLocationText = MY_LOCATION[language.language];
      this.alreadyRatedText = ALREADY_RATED[language.language].replace(
        '{0}',
        STATION[language.language].toLowerCase()
      );
      this.rateText = RATE_STATION[language.language];
      this.platformText = PLATFORM[language.language]
      this.specialMessagesText = SPECIAL_DATA_TEXTS.specialMessges[language.language]
      this.onlyDropOffText = DROP_OFF_ONLY[language.language]
      this.pickUpOnlyText = PICK_UP_ONLY[language.language]
      this.noPickupOrDropOffText = NO_PICKUP_OR_DROP_OFF[language.language]
      this.initButtons(language);
    });
  }

  initButtons(language: Language) {
    this.resultButtons = [
      {
        id: 'specialMessages',
        label: SPECIAL_MESSAGES[language.language],
        icon: 'message-exclamation',
        ariaHaspopup: 'dialog',
        onClick: () =>
          this.modalService.openSpecialMessagesModal(this.stop.specialMessages),
        name: 'specialMessages',
        counter: new Set(this.stop.specialMessages.map(m => m.messageId)).size,
        ariaLabel: specialMessagesButtonAriaLabel(
          language.language,
          SPECIAL_MESSAGES[language.language],
          new Set(this.stop.specialMessages.map(m => m.messageId)).size
        ),
      },
      {
        label: SUBMIT_REQUEST_COMPLAIN[language.language],
        icon: 'circle-exclamation',
        onClick: () => this.handleSubmitRequestClick(),
        name: 'submitComplain',
      },
      {
        label: NAVIGATE_TO_STATION[language.language],
        icon: 'location-arrow',
        onClick: () => this.navigateToStation(),
        name: 'navigateStation',
      },

      {
        label: SIGN_UP_FOR_REPORTS[language.language],
        icon: 'mobile-signal',
        name: 'signUpReports',
        externalHref: SIGN_UP_FOR_REPORTS_URL,
        externalLinkHint:
          SIGN_UP_FOR_REPORTS_EXTERNAL_HINT[language.language],
      },
    ].filter(
      (button) =>
        button.name !== 'specialMessages' ||
        (button.name === 'specialMessages' &&
          button.counter &&
          button.counter > 0)
    );
  }

  handleSubmitRequestClick(): void {
    const url = this.languageService.getSelectedLanguage().symbol === 'he' ? environment.complaintUrl : environment.complaintUrlMultiLanguage;
    window.open(url, '_blank');
  }

  getLineSpecialMessagesCount(line: Route) {
    return new Set(line.specialMessages.map(m => m.messageId)).size;
  }

  openSpecialMessages(messages: SpecialMessage[]) {
    this.modalService.openSpecialMessagesModal(messages);
  }

  navigateToStation() {
    // Check if permissions are already granted
    if (this.userLocationService.hasPermissions) {
      this.processNavigationWithLocation();
    } else {
      // Force a permission request since user explicitly clicked "Navigate"
      this.userLocationService
        .requestLocationPermissionForced()
        .subscribe((granted) => {
          if (granted) {
            this.processNavigationWithLocation();
          } else {
            // If permission denied, navigate without location data
            this.processNavigationWithoutLocation();
          }
        });
    }
  }

  private processNavigationWithLocation() {
    this.routePlanningService._mapOverlaySub.next(null);
    this.navigateToStationEvent.emit(true)
    const params = {
      tab: eTab.SOURCE_DESTINATION,
      dll: `${this.stop.lat}_${this.stop.lng}`,
      dest: `${this.stop.streetName} ${this.stop.streetNumber} ${this.stop.cityName} - ${this.stop.name[this.languageService.getSelectedLanguage().symbol] || this.stop.name.he || ''} ${this.stop.stopcode}`,
      saveParams: true,
      org: null,
      oll: null
    };

    const coordinates = this.userLocationService.userLocation;
    if (coordinates) {
      params.oll = `${coordinates.lat}_${coordinates.lng}`
      params.org = this.myLocationText
      this.navigateToStationEvent.emit(false)
      this.closeCardEvent.emit();
      this.queryParamsService.setQueryParams(params);

      // this.autoCompleteService.getAddressDataByCoordinates(coordinates).subscribe({
      //   next: (response) => {

      //     if (response.success && response.data) {
      //       params.org =  response.data.addressDetails.label
      //     } else {
      //       params.org = this.myLocationText
      //     }
      //     this.navigateToStationEvent.emit(false)
      //     this.closeCardEvent.emit();
      //     this.queryParamsService.setQueryParams(params);
      //   },
      //   error: () => {
      //     params.org = this.myLocationText

      //     this.navigateToStationEvent.emit(false)
      //     this.closeCardEvent.emit();
      //     this.queryParamsService.setQueryParams(params);
      //   },
      // });
    } else {
      this.processNavigationWithoutLocation();
    }
  }

  private processNavigationWithoutLocation() {
    const params = {
      tab: eTab.SOURCE_DESTINATION,
      dll: `${this.stop.lat}_${this.stop.lng}`,
      dest: `${this.stop.streetName} ${this.stop.streetNumber} ${this.stop.cityName} - ${this.stop.name[this.languageService.getSelectedLanguage().symbol] || this.stop.name.he || ''} ${this.stop.stopcode}`,
      saveParams: true,
    };
    this.closeCardEvent.emit();
    this.queryParamsService.setQueryParams(params);
  }

  onAgencyClick(agencyId: number) {
    this.modalService.openAgencyContactInfoModal(agencyId, false);
  }

  openStationImagesCarousel(photoIndex: number) {
    this.modalService.openDialog(ImageCarouselComponent, {
      data: {
        imagesUrl: this.stop.photos,
        activePhotoIndex: photoIndex,
      },
    });
  }

  /** Localized alt text for a single station photo thumbnail. */
  stationPhotoAlt(index: number): string {
    return this.formatTemplate(STATION_PHOTO_ALT[this.languageKey], [
      String(index + 1),
      String(this.stop?.photos?.length ?? 0),
      this.getLocalizedStopName(),
    ]);
  }

  /**
   * Localized accessible name for the photo thumbnail button so SR users hear
   * which photo will open and that it opens a fullscreen carousel (dialog).
   */
  stationPhotoButtonAriaLabel(index: number): string {
    return this.formatTemplate(OPEN_STATION_PHOTO_ARIA_LABEL[this.languageKey], [
      String(index + 1),
      String(this.stop?.photos?.length ?? 0),
      this.getLocalizedStopName(),
    ]);
  }

  /**
   * Resolve the station name from its MultiLanguage shape using the active
   * language symbol with a Hebrew fallback (matches the rest of the app).
   */
  private getLocalizedStopName(): string {
    const name = this.stop?.name;
    if (!name) {
      return '';
    }
    if (typeof name === 'string') {
      return name;
    }
    const symbol = this.languageService.getSelectedLanguage().symbol;
    return name[symbol] || name.he || '';
  }

  private formatTemplate(template: string, values: string[]): string {
    if (!template) {
      return '';
    }
    return values.reduce(
      (acc, value, idx) => acc.replace(`{${idx}}`, value ?? ''),
      template
    );
  }


  openStationRatingPopUp(rating: Rating) {
    this.modalService
      .openPopUp(LineRatingComponent, {
        data: {
          entityId: this.stop.stopcode,
          rating: rating,
          entityType: 0,
        },
      })
      .subscribe((newRating: Rating) => {
        if (!!newRating) {
          if(newRating.ratingsCount >= 5) {
            this.stop.rating = newRating;
          }
          this.isRatedStop = true;
          const expirationDate = new Date();
          expirationDate.setHours(expirationDate.getHours() + 12); // Expires in 12 hours
          const item = {
            value: this.stop.stopcode.toString(),
            expiration: expirationDate.getTime(),
          };

          let ratedStops = JSON.parse(localStorage.getItem('ratedStopCode') || '[]');
          ratedStops.push(item);
          localStorage.setItem('ratedStopCode', JSON.stringify(ratedStops));
        }
      });
  }

  isOnlyPickUp(routeId: number) {
    const routeStopTime = this.stop.stopTimes.find(stopTime => stopTime.routeId === routeId);
    return routeStopTime?.isPickUp && !routeStopTime?.isDropOff;
  }

  isOnlyDropOff(routeId: number) {
    const routeStopTime = this.stop.stopTimes.find(stopTime => stopTime.routeId === routeId);
    return routeStopTime?.isDropOff && !routeStopTime?.isPickUp;
  }

  isNoPickupOrDropOff(routeId: number) {
    const routeStopTime = this.stop.stopTimes.find(stopTime => stopTime.routeId === routeId);
    return routeStopTime?.isPickUp && routeStopTime?.isDropOff;
  }

  isMobile() {
    return this.resizeService.isMobile;
  }

  getTripHeadSign(route: Route) {
    if(route.agencyId === 2) {
      return route.routeLongName;
    }
    return route.headsign[this.languageService.getSelectedLanguage().symbol] || route.headsign.he || ""
  }
}
